import { render, staticRenderFns } from "./KBASearch.vue?vue&type=template&id=3f01f2a1&scoped=true&"
import script from "./KBASearch.vue?vue&type=script&lang=js&"
export * from "./KBASearch.vue?vue&type=script&lang=js&"
import style0 from "./KBASearch.vue?vue&type=style&index=0&id=3f01f2a1&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f01f2a1",
  null
  
)

export default component.exports